import { Link } from "wouter";
import { BookOpen } from "lucide-react";
import { guideLinksFor } from "@/lib/blog";
import { useLocale } from "@/hooks/useLocale";

/** Short "Read the guide" block: links to the newest blog posts for a tool / persona / workflow / topic. */
export function GuideLinks({ kind, id, heading = "Guides and tutorials", variant = "section" }: { kind: "tools" | "personas" | "workflows" | "topics"; id: string; heading?: string; variant?: "section" | "plain" }) {
  const { localizedHref } = useLocale();
  const links = guideLinksFor(kind, id);
  if (!links.length) return null;
  if (variant === "plain") {
    return (
      <ul className="mt-4 space-y-2 text-sm" aria-label={heading}>
        {links.map((l) => (
          <li key={l.slug}>
            <Link href={localizedHref(`/blog/${l.slug}`)} className="text-primary hover:underline">{l.title}</Link>
          </li>
        ))}
      </ul>
    );
  }
  return (
    <section className="container max-w-4xl mx-auto py-8 px-4" aria-label={heading}>
      <h2 className="text-lg font-semibold mb-3 flex items-center gap-2"><BookOpen className="h-4 w-4 text-primary" />{heading}</h2>
      <ul className="space-y-2 text-sm">
        {links.map((l) => (
          <li key={l.slug}>
            <Link href={localizedHref(`/blog/${l.slug}`)} className="text-primary hover:underline">{l.title}</Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
